export const PATCH_NOTES_PROPERTY = { title: "title", date: "publicationDate" };
